const initsWith = (filter, word) => new RegExp(`^${filter}.*`, 'i').test(word)

export const filterByIgreja = (igreja = '', celula) => {
  return celula.igreja && celula.igreja.descricao.toLowerCase() === igreja.toLowerCase().trim()
}



// WEBPACK FOOTER //
// ./src/Celula/filters.js